export default function BotanicalDivider({ label }) {
    return (
        <div
            className="flex items-center justify-center gap-4 my-10"
            aria-hidden={!label}
        >
            <svg
                width="80"
                height="14"
                viewBox="0 0 80 14"
                fill="none"
                className="text-[#a8b9a0]"
            >
                <path
                    d="M0 7 H30"
                    stroke="currentColor"
                    strokeWidth="1"
                    strokeLinecap="round"
                />
                <path
                    d="M35 7 C 37 3, 40 3, 42 7 C 40 11, 37 11, 35 7 Z"
                    stroke="currentColor"
                    strokeWidth="1"
                    fill="none"
                />
                <circle cx="38.5" cy="7" r="1.2" fill="currentColor" />
            </svg>
            {label && (
                <span
                    className="eyebrow"
                    style={{ color: "var(--color-sage-deep)" }}
                >
                    {label}
                </span>
            )}
            <svg
                width="80"
                height="14"
                viewBox="0 0 80 14"
                fill="none"
                className="text-[#a8b9a0]"
            >
                <path
                    d="M38 7 C 40 3, 43 3, 45 7 C 43 11, 40 11, 38 7 Z"
                    stroke="currentColor"
                    strokeWidth="1"
                    fill="none"
                />
                <circle cx="41.5" cy="7" r="1.2" fill="currentColor" />
                <path
                    d="M50 7 H80"
                    stroke="currentColor"
                    strokeWidth="1"
                    strokeLinecap="round"
                />
            </svg>
        </div>
    );
}
